import Vue from "vue"
import md5 from "md5"
import API from "../../Api"

Vue.mixin({
    methods: {
        NullOrUndefined(value)
        {
            return value === undefined || value === null;
        },
        importSnapshotsByJson: function (formValue, id)
        {
            let url = "snapshot/GetLastSnapshotJson?id=" + id;

            this.cancelToken = API.CancelToken.source();
            
            return API.get(url, {
                cancelToken: this.cancelToken.token
            }).then((res) => {

                if (res.data) {
                    formValue.snapshots = res.data;
                }
            }).catch((res) => {
                console.log(res);
            }).finally(() => {
                
            });  
        },
        importSupplyPlansByJson: function (formValue, id) {
            //var id = this.$route.params.id;                
            //debugger;
            let url = "supplyplan/GetSupplyPlanJson?id=" + id;

            this.cancelToken = API.CancelToken.source();


            return API.get(url, {
                cancelToken: this.cancelToken.token
            }).then((res) => {

                if (res.data) {

                    formValue.autoGenerateSupplyPlans = false;
                    formValue.supplyPlans = res.data;

                    for (var i = 0; i < formValue.sites.length; i++) {
                        formValue.sites[i].supplyPlans = [];
                    }

                    for (var i = 0; i < formValue.depots.length; i++) {
                        formValue.depots[i].supplyPlans = [];
                    }

                    for (var i = 0; i < formValue.supplyPlans.length; i++) {

                        let plan = formValue.supplyPlans[i];

                        if (plan.sites.length <= 0)
                            continue;

                        for (let siteIndex = 0; siteIndex < plan.sites.length; siteIndex++) {

                            var innerIndex = formValue.sites.findIndex(x => x.id === plan.sites[siteIndex]);

                            if (innerIndex > -1) {

                                let sitePlanReference = {
                                    supplyPlan: plan.id,
                                    startDate: plan.defaultStartDate,
                                    siteId: plan.sites[siteIndex]
                                };

                                formValue.sites[innerIndex].supplyPlans.push(sitePlanReference);
                            }
                        }

                    }

                    this.$store.dispatch("saveCurrentForecastVersion");
                }
            }).catch((res) => {
                console.log(res);
            }).finally(() => {
                
            });
        },
        updateShipperReviews: function (formValue) {
            const shipperTypes = formValue.shipperTypes;
            const chains = this.cloneObject(formValue.supplyChain);
            const finalList = [];
            var thisRef = this;
            // First, build chain and remove doublet chains
            const newChains = [];
            const newChainsHasList = [];

            if (chains !== undefined && chains !== null) {
                chains.forEach((supplyChain) => {
                    const newChain = [];
                    for (let sc of supplyChain.supplyChains) {
                        const depot = formValue.depots.find(x => x.id === sc.depotReference.id);

                        if (thisRef.NullOrUndefined(depot)) 
                            continue;

                        const c = {
                            type: "maindepot",
                            depot: {
                                id: sc.depotReference.id,
                                name: depot.name
                            },
                            receiving: {
                                id: sc.depotReference.id,
                                name: depot.name
                            }
                        };

                        newChain.push(c);
                        newChain.push(...thisRef.allSupplyChainDepots(sc, formValue.depots,formValue.sites));
                    };

                    // Hash list to check for doublets
                    newChain.forEach((sortChan) => {
                        const hashed = md5(sortChan.depot.name + sortChan.receiving.name);
                        if (newChainsHasList.indexOf(hashed) == -1) {
                            newChainsHasList.push(hashed);
                            newChains.push(sortChan);
                        }
                    });
                });
            }
            if (shipperTypes !== undefined && shipperTypes !== null) {
                shipperTypes.forEach((type) => {
                    if (this.NullOrUndefined(type) || type.constraint === "")
                        return false;

                    let constraint = formValue.shipping.packing.constraints.find(x => x.id === type.constraint);
                    if (this.NullOrUndefined(constraint))
                        return false;

                    var constrainName = constraint.name;

                    newChains.forEach((chain) => {

                        if (this.NullOrUndefined(chain))
                            return;
                        
                        if (chain.type === "maindepot" ||
                            (chain.type === "site" && type.allowFor.sites) ||
                            (chain.type === "depot" && type.allowFor.depots)) {
                            let propName = type.name;

                            propName += `, ${constrainName}, ${type.capacity}`;

                            let receiver = formValue.sites.find(x => x.id === chain.receiving.id);

                            if (this.NullOrUndefined(receiver))
                            {
                                receiver = formValue.depots.find(x=>x.id === chain.receiving.id);
                            }
                            

                            let receivingName = receiver.name;
                            let depotName = formValue.depots.find(x=>x.id === chain.depot.id).name;
                            

                            const t = {
                                hash: this.hashString(chain.depot.id + chain.receiving.id + propName),
                                depotName: depotName,
                                depotId: chain.depot.id,
                                receivingName: receivingName,
                                receivingId: chain.receiving.id,
                                properties: propName,
                                cost: type.defaultCost,
                                defaultCost: type.defaultCost,
                                isDeleted: false,
                                isDefault: true,
                                constraintId: type.constraint,
                                isHidden: chain.type === "maindepot",
                                allowFor: type.allowFor
                            };

                            finalList.push(t);
                        }
                    });
                });
            }
            if (!this.NullOrUndefined(formValue.shipperReview)) {
                // Check if some items isDefault or isDeleted
                formValue.shipperReview.forEach((r) => {
                    if (!r.isDefault || r.isDeleted) {
                        const row = finalList.find(x => x.hash === r.hash);
                        if (row != null) {
                            row.isDefault = r.isDefault;
                            row.isDeleted = r.isDeleted;
                            row.cost = r.cost;
                            row.properties = r.properties;
                        }
                    }
                });
            }
            formValue.shipperReview = finalList;
        },
        allSupplyChainDepots: function (sc, depots, sites, list) {
            if (!list) {
                list = [];
            }

            sc.deliverySites.forEach((d) => {

                const item = {
                    type: "site",
                    depot: {
                        id: sc.depotReference.id,
                        name: depots.find(x => x.id === sc.depotReference.id).name
                    },
                    receiving: {
                        id: d.siteReference.id,
                        name: sites.find(x => x.id === d.siteReference.id).name
                    }
                };
                list.push(item);

                if (d.deliverySites.length > 0 || d.deliveryDepots.length > 0) {
                    this.allSupplyChainDepots(d, depots,sites, list);
                }
            });

            sc.deliveryDepots.forEach((d) => {
                const item = {
                    type: "depot",
                    depot: {
                        id: sc.depotReference.id,
                        name: depots.find(x => x.id === sc.depotReference.id).name
                    },
                    receiving: {
                        id: d.depotReference.id,
                        name: depots.find(x => x.id === d.depotReference.id).name 
                    }
                };
                list.push(item);

                if (d.deliveryDepots.length > 0 || d.deliverySites.length > 0) {
                    this.allSupplyChainDepots(d, depots, sites, list);
                }
            });

            return list;
        }
        ,
        /*
        updateMetaNameReferences: function (data) {
            if (!data)
                return;

            const references = {
                siteReferences: [],
                depotReferences: [],
                // dispensingReferences: []
            };

            // fetch references from supply chains
            if (data.supplyChain && data.supplyChain.length) {
                function crawler(source, destination) {
                    if (!(source && source.depotReference))
                        return;

                    // push reference to current destination
                    destination.push(source.depotReference);

                    // continue crawling sites
                    if (source.deliverySites && source.deliverySites.length) {
                        const sites = source.deliverySites;
                        for (let i = 0; i < sites.length; i++) {
                            crawler(sites[i], references.siteReferences);
                        }
                    }

                    // continue crawling depots
                    if (source.deliveryDepots && source.deliveryDepots.length) {
                        const depots = source.deliveryDepots;
                        for (let i = 0; i < depots.length; i++) {
                            crawler(depots[i], references.depotReferences);
                        }
                    }
                }

                for (let i = 0; i < data.supplyChain.length; i++) {
                    const chains = data.supplyChain[i].supplyChains;
                    for (let j = 0; j < chains.length; j++) {
                        crawler(chains[j], references.depotReferences);
                    }
                }
            }

            // fetch references from planned batches
            if (data.production && data.production.plannedBatchs && data.production.plannedBatchs.length) {
                const plannedBatchs = data.production.plannedBatchs;
                for (let i = 0; i < plannedBatchs.length; i++) {
                    const pb = plannedBatchs[i];

                    if (pb && pb.depots && pb.depots.length) {
                        references.depotReferences.push(...pb.depots);
                    }
                }
            }

            // fetch references from batch templates
            if (data.production && data.production.batchTemplates && data.production.batchTemplates.length) {
                const batchTemplates = data.production.batchTemplates;
                for (let i = 0; i < batchTemplates.length; i++) {
                    const bt = batchTemplates[i];

                    if (bt && bt.depots && bt.depots.length) {
                        references.depotReferences.push(...bt.depots);
                    }
                }
            }

            const depots = data.depots;
            for (let i = 0; i < depots.length; i++) {
                const id = depots[i].id;
                const name = depots[i].name;
                if (!(id && name))
                    continue;

                references.depotReferences.filter(x => x.id === id).forEach(x => { x.idMetaValueName = name });
            }

            const sites = data.sites;
            for (let i = 0; i < sites.length; i++) {
                const id = sites[i].id;
                const name = sites[i].name;
                if (!(id && name))
                    continue;

                references.siteReferences.filter(x => x.id === id).forEach(x => { x.idMetaValueName = name });
            }
        },
        */
        toCustomFormName(string) {
            const base = window.btoa(string).slice(0, 30);

            return "custom" + base;
        },
        createEditorMenuUrl(editorType, section, level) {
            let url = "/" + editorType + "/" + this.$route.params.id + "/" + section + "/" + level;

            if (this.$route.params.versionId)
                url += "/" + this.$route.params.versionId;

            return url;
        },
        cloneObject(object) {
            if (typeof object == 'undefined') {

                return object;

            } else {

                var stringVal = JSON.stringify(object);

                var retObj = JSON.parse(stringVal);

                return retObj;
            }
        },
        replaceAll(str, find, replace) {
            return str.split(find).join(replace);
        },
        hashString(value) {
            let hash = 0;
            let i;
            let chr;
            if (value.length === 0) return hash;
            for (i = 0; i < value.length; i++) {
                chr = value.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        },
        isObject(item) {
            return (item && typeof item === 'object' && !Array.isArray(item));
        },
        isEmptyObject(obj) {
            return Object.keys(obj).length === 0 && obj.constructor === Object;
        },
        mergeDeep(target, ...sources) {
            if (!sources.length) return target;
            const source = sources.shift();

            if (this.isObject(target) && this.isObject(source)) {
                for (const key in source) {
                    if (this.isObject(source[key])) {
                        if (!target[key]) Object.assign(target, { [key]: {} });
                        this.mergeDeep(target[key], source[key]);
                    } else {
                        Object.assign(target, { [key]: source[key] });
                    }
                }
            }

            return this.mergeDeep(target, ...sources);
        },
        isNegativeOrPositive(e) {
            const which = e.which;

            return (
                which == 8 ||
                    which == 9 ||
                    which == 13 ||
                    which == 43 ||
                    which == 45 || 
                    which == 46 ||
                    which == 110 ||
                    which == 190 ||
                    (which >= 35 && which <= 40) ||
                    (which >= 48 && which <= 57) ||
                    (which >= 96 && which <= 105));
        },
        isKeyNumber(e, allowNegative) {
            const which = e.which;

            return (
                ((which === 173 || which === 109) && allowNegative) ||
                which === 8 ||
                which === 9 ||
                which === 13 ||
                which === 46 ||
                which === 110 ||
                which === 190 ||
                (which >= 35 && which <= 40) ||
                (which >= 48 && which <= 57) ||
                (which >= 96 && which <= 105));
        },
        getNestedValue(object, field) {
            
            if (!object === undefined || object === null)
                return null;
            
            const path = field.split('.');
            while (path.length && (object = object[path.shift()]));
            return object;
        },
        //this is specifically for tree object. There is a bug if return string empty for initialization
        //described here: https://githubmemory.com/repo/riophae/vue-treeselect/issues/441
        getNestedValueNullIfEmpty(object, field) {
            if (!object)
                return null;

            
            
            const path = field.split('.');
            while (path.length && (object = object[path.shift()]));

            
            if (object=="")
                return null;
            return object;
        },
        setNestedValue(form, value, key) {
            const levels = key.split(".");
            let curLevel = form;
            let i = 0;
            while (i < levels.length - 1) {
                curLevel = curLevel[levels[i]];
                if (curLevel == undefined) {
                    form[levels[i]] = {}
                    curLevel = form[levels[i]];
                }

                i++;
            }

            curLevel[levels[levels.length - 1]] = value;
        },
        
        formatIsoDateToShortDate(dateValue) {
            if (this.NullOrUndefined(dateValue))
                return "";

            let d = new Date(dateValue);
            //stolen from here: https://www.webdevelopersnotes.com/javascript-date-and-time
            /* native js cannot format to month names */
            const m_names = ["Jan", "Feb", "Mar",
                "Apr", "May", "Jun", "Jul", "Aug", "Sep",
                "Oct", "Nov", "Dec"];

            let curr_date = d.getDate();
            let curr_month = d.getMonth();
            let curr_year = d.getFullYear();

            return curr_date + "-" + m_names[curr_month] + "-" + curr_year;
        },
        aggregationCleanSelected(formValue, list) {
            // Selected rows
            const newList = [];
            for (let row of formValue.selectedRows) {
                const studyId = row.split('_')[0];
                if (formValue.studies.indexOf(studyId) > -1)
                    newList.push(row)
            }
            formValue.selectedRows = newList;

            // Clean list
            if (formValue[list]) {
                let i = formValue[list].length;
                while (i--) {
                    const id = formValue[list][i].id;
                    if (formValue.selectedRows.indexOf(id) === -1) {
                        formValue[list].splice(i, 1);
                    }
                }
            }
        },
        GetWindowsCopyStyleTitle(title) {
            var copyCount = 1;
            if (title.includes("copy copy")) {
                var copies = title.split(" copy");
                copyCount = copies.length;
                title = title.replace(" copy", "");
            }
            //modern
            const regex = / - copy\(([\d]+)\)/gm;
            var match = regex.exec(title);
            if (match != null && match.length > 0) {
                copyCount = 1 + (match[1] * 1);
                title = title.replace(regex, "");
            }
            var newTitle = title + " - copy(" + copyCount + ")";
            return newTitle;

        },
        saveFile(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                // IE and Edge provides this functionality natively
                window.navigator.msSaveOrOpenBlob(blob, filename);
                return;
            }

            // setup
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            document.body.appendChild(a);

            // download
            a.href = url;
            a.download = filename;
            a.click();

            // cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }
    }
});
